import scrool1 from "../assets/scrools/scrool1.webp";
import scrool2 from "../assets/scrools/scrool2.webp";
import scrool3 from "../assets/scrools/scrool3.webp";
import scrool4 from "../assets/scrools/scrool7.webp";
import scrool5 from "../assets/scrools/scrool5.webp";
import scrool6 from "../assets/scrools/scrool6.webp";
import { FaClock } from "react-icons/fa";
import { IoStatsChartOutline } from "react-icons/io5";
import { IoBookSharp } from "react-icons/io5";
import { FaStarOfLife } from "react-icons/fa6";
import { PiStudentBold } from "react-icons/pi";

export const items = [
    {
        image: scrool2,
        name: "Training Institute",
        work: "Javascript Campus.",
        clockIcon: <FaClock />,
        clock: "10 Weeks",
        levelIcon: <IoStatsChartOutline />,
        level: "All Levels",
        lesionIcon: <IoBookSharp />,
        lession: "5 Lessons",
        quizeIcon: <FaStarOfLife />,
        quizes: "0 Quizzes",
        studentIcon: <PiStudentBold />,
        student: "0 Students",
        price: "$50.00",
      },
  {
    image: scrool1,
    name: "Training Institute",
    work: "Management prog.",
    clockIcon: <FaClock />,
    clock: "10 Weeks",
    levelIcon: <IoStatsChartOutline />,
    level: "All Levels",
    lesionIcon: <IoBookSharp />,
    lession: "5 Lessons",
    quizeIcon: <FaStarOfLife />,
    quizes: "0 Quizzes",
    studentIcon: <PiStudentBold />,
    student: "0 Students",
    price: "$95.00",
  },
  {
    image: scrool6,
    name: "Training Institute",
    work: "Project Learning.",
    clockIcon: <FaClock />,
    clock: "10 Weeks",
    levelIcon: <IoStatsChartOutline />,
    level: "All Levels",
    lesionIcon: <IoBookSharp />,
    lession: "0 Lessons",
    quizeIcon: <FaStarOfLife />,
    quizes: "0 Quizzes",
    studentIcon: <PiStudentBold />,
    student: "0 Students",
    price: "Free",
  },
  
  {
    image: scrool3,
    name: "Training Institute",
    work: "Development Prog.",
    clockIcon: <FaClock />,
    clock: "10 Weeks",
    levelIcon: <IoStatsChartOutline />,
    level: "All Levels",
    lesionIcon: <IoBookSharp />,
    lession: "5 Lessons",
    quizeIcon: <FaStarOfLife />,
    quizes: "0 Quizzes",
    studentIcon: <PiStudentBold />,
    student: "0 Students",
    price: "$300.00",
  },
  {
    image: scrool4,
    name: "Training Institute",
    work: "Sample Course.",
    clockIcon: <FaClock />,
    clock: "10 Weeks",
    levelIcon: <IoStatsChartOutline />,
    level: "All Levels",
    lesionIcon: <IoBookSharp />,
    lession: "71 Lessons",
    quizeIcon: <FaStarOfLife />,
    quizes: "6 Quizzes",
    studentIcon: <PiStudentBold />,
    student: "5 Students",
    price: "Free",
  },
  {
    image: scrool5,
    name: "Training Institute",
    work: "Leaning Seminar.",
    clockIcon: <FaClock />,
    clock: "10 Weeks",
    levelIcon: <IoStatsChartOutline />,
    level: "All Levels",
    lesionIcon: <IoBookSharp />,
    lession: "5 Lessons",
    quizeIcon: <FaStarOfLife />,
    quizes: "0 Quizzes",
    studentIcon: <PiStudentBold />,
    student: "0 Students",
    price: "Free",
  },
 
];
